import type { RingFinishEnum } from '@jouzen/ecom-components/v3/enums/ringFinish';
import type { FinishSelectionData } from '@jouzen/ecom-components/v3/FinishRadioSelectors';
import { RingFinishSelections } from '@jouzen/ecom-components/v3/RingFinishSelections';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import { EventType } from '@/analytics/types';

import type { CurrentRouteValues } from '../_hooks/useCurrentRoute';

export interface FinishSelectionsProps {
  readonly currencyCode: string;
  readonly currentRoute: CurrentRouteValues;
  readonly initialSelectedFinish: RingFinishEnum;
  readonly onChange: (value: string) => void;
  readonly ringFinishesData: FinishSelectionData[];
  readonly subtitle: MessageKey;
}

const FinishSelections = ({
  currencyCode,
  currentRoute,
  initialSelectedFinish,
  onChange,
  ringFinishesData,
  subtitle,
}: FinishSelectionsProps) => {
  const t = useTranslations();

  const handleChange = (finish: string) => {
    void window.ouraAnalytics.track(EventType.ModuleClicked, {
      cta: 'finish',
      location: 'pdp',
      step: 1,
    });
    currentRoute.pushFinish(finish as RingFinishEnum);
    onChange(finish);
  };

  return (
    <>
      <Typography
        className="mb-3 leading-snug text-gray-400"
        Element="h2"
        variant="h6"
      >
        {t(subtitle)}
      </Typography>
      <RingFinishSelections
        currencyCode={currencyCode}
        initialSelectedFinish={initialSelectedFinish}
        label={t('pdp_step_style_next')}
        onChange={handleChange}
        ringFinishesData={ringFinishesData}
      />
    </>
  );
};

export default FinishSelections;
